import { withSuspense } from '@/ui/utils/withSuspense'

import { LeaderboardTable } from './components/leaderboard-table/LeaderboardTable'
import { useLeaderboard } from './logic/useLeaderboard'
import { LeaderboardSkeleton } from './components/skeleton/LeaderboardSkeleton'
import { usePointsLeaderboard } from '@/domain/merkl/points-leaderboard/usePointsLeaderboard'
import { useChainId } from 'wagmi'

function LeaderboardContainer() {
  const chainId = useChainId()
  const { data: buddiesLeaderboard, isLoading: isBuddiesLeaderboardLoading } = useLeaderboard()
  const { data: pointsLeaderboard, isLoading: isPointsLeaderboardLoading } = usePointsLeaderboard({ chainId })
  const isLoading = isBuddiesLeaderboardLoading || isPointsLeaderboardLoading

  return isLoading ? (
    <LeaderboardSkeleton />
  ) : (
    <LeaderboardTable buddiesLeaderboard={buddiesLeaderboard} pointsLeaderboard={pointsLeaderboard} />
  )
}

const LeaderboardContainerWithSuspense = withSuspense(LeaderboardContainer, LeaderboardSkeleton)
export { LeaderboardContainerWithSuspense as LeaderboardContainer }
